import * as _ from 'lodash';
import DecimalForGlobals from '../impuestos/DecimalForGlobals';

class PagosImpuestosGlobalesCalculator {
  data = {};

  constructor(data) {
    this.data = data;
  }

  static make(data) {
    return new PagosImpuestosGlobalesCalculator(data);
  }

  apply() {
    let items = _.get(this.data, 'DoctoRelacionado') || [];

    const traslados = this._getTraslados(items);
    const retenciones = this._getRetenciones(items);

    return {
      ...traslados,
      ...retenciones,
    };
  }

  _getTraslados(items) {
    let traslados = {};

    for (const item of items) {
      let impuestos = _.get(item, 'ImpuestosDR.TrasladosDR.TrasladoDR', []);

      traslados = this._calculate(impuestos, item, traslados);
    }

    traslados = this._getValues(traslados);

    if (!traslados) {
      return {};
    }

    return {
      TrasladosP: {
        TrasladoP: traslados.map((item) => {
          item.BaseP = DecimalForGlobals.make(item.BaseP).toFixed();

          if (!!item.ImporteP) {
            item.ImporteP = DecimalForGlobals.make(item.ImporteP).toFixed();
          }

          return item;
        }),
      },
    };
  }

  _getRetenciones(items) {
    let retenciones = {};

    for (const item of items) {
      let impuestos = _.get(item, 'ImpuestosDR.RetencionesDR.RetencionDR', []);

      retenciones = this._calculate(impuestos, item, retenciones, 'retenciones');
    }

    retenciones = this._getValues(retenciones);

    if (!retenciones) {
      return {};
    }

    return {
      RetencionesP: {
        RetencionP: retenciones.map((item) => {
          item.ImporteP = DecimalForGlobals.make(item.ImporteP).toFixed();

          return item;
        }),
      },
    };
  }

  _calculate(impuestos, documento, result, type = 'traslados',) {
    let index;
    let data = {};

    for (const impuesto of impuestos) {
      if (impuesto.TipoFactorDR === 'Exento') {
        [data, index] = this._calculateExento(impuesto, result, documento, type);
      } else {
        [data, index] = this._calculateImpuestos(impuesto, result, documento, type);
      }

      result = {
        ...result,
        [index]: data,
      };
    }

    return result;
  }

  _calculateExento(impuesto, result, documento, type) {
    const index = `${impuesto.ImpuestoDR}-${impuesto.TipoFactorDR}`;

    let data = result[index] ?? null;

    if (data && type === 'traslados') {
      data.BaseP += this._calculateBaseP(impuesto, documento);
    } else if (data && type !== 'traslados') {
      data.BaseP += this._calculateBaseP(impuesto, documento);
    } else if (type === 'traslados') {
      data = {
        BaseP: this._calculateBaseP(impuesto, documento),
        TipoFactorP: impuesto.TipoFactorDR,
        ImpuestoP: impuesto.ImpuestoDR,
      };
    } else {
      data = {
        ImpuestoP: impuesto.ImpuestoDR,
      };
    }

    return [data, index];
  }

  _calculateImpuestos(impuesto, result, documento, type) {
    const index = `${impuesto.ImpuestoDR}-${impuesto.TipoFactorDR}-${impuesto.TasaOCuotaDR}`;

    let data = result[index] ?? null;

    if (data && type === 'traslados') {
      data.BaseP += this._calculateBaseP(impuesto, documento);
      data.ImporteP += this._calculateImporteP(impuesto, documento);
    } else if (data && type !== 'traslados') {
      data.ImporteP += this._calculateImporteP(impuesto, documento);
    } else if (type === 'traslados') {
      data = {
        BaseP: this._calculateBaseP(impuesto, documento),
        ImpuestoP: impuesto.ImpuestoDR,
        TipoFactorP: impuesto.TipoFactorDR,
        TasaOCuotaP: impuesto.TasaOCuotaDR,
        ImporteP: this._calculateImporteP(impuesto, documento),
      };
    } else {
      data = {
        ImpuestoP: impuesto.ImpuestoDR,
        ImporteP: this._calculateImporteP(impuesto, documento),
      };
    }

    return [data, index];
  }

  _getValues(values) {
    values = Object.values(values);

    if (values.length === 0) {
      return null;
    }

    return values;
  }

  _calculateBaseP(impuesto, documento) {
    const base = parseFloat(impuesto.BaseDR ?? 0);
    const equivalencia = parseFloat(documento.EquivalenciaDR ?? 1);

    return parseFloat(base / equivalencia);
  }

  _calculateImporteP(impuesto, documento) {
    const base = parseFloat(impuesto.ImporteDR ?? 0);
    const equivalencia = parseFloat(documento.EquivalenciaDR ?? 1);

    return parseFloat(base / equivalencia);
  }
}

export default PagosImpuestosGlobalesCalculator;
